import { render } from "./elements_form_errors.vue?vue&type=template&id=39b31852"
import script from "./elements_form_errors.vue?vue&type=script&lang=js"
export * from "./elements_form_errors.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__